module.exports = __webpack_public_path__ + "img/card3.a6901819.png";